import {
  ManageCachePage,
  ManageConsumersPage,
  SubmitOrderLogPage,
  VendorQuoteLogPage,
} from 'dashboard/pages';
import {
  dashboardManageCachePath,
  dashboardManageConsumersPath,
  dashboardSubmitOrderLogPath,
  dashboardVendorQuoteLogPath,
} from 'dashboard/routes/routePaths';
import { Route } from 'router/types';

export const dashboardManageCache: Route = {
  element: <ManageCachePage />,
  exact: true,
  isPrivate: true,
  path: dashboardManageCachePath(),
};

export const dashboardManageConsumers: Route = {
  element: <ManageConsumersPage />,
  exact: true,
  isPrivate: true,
  path: dashboardManageConsumersPath(),
};

export const dashboardSubmitOrderLog: Route = {
  element: <SubmitOrderLogPage />,
  exact: true,
  isPrivate: true,
  path: dashboardSubmitOrderLogPath(),
};

export const dashboardVendorQuoteLog: Route = {
  element: <VendorQuoteLogPage />,
  exact: true,
  isPrivate: true,
  path: dashboardVendorQuoteLogPath(),
};

export const dashboard = [
  dashboardVendorQuoteLog,
  dashboardManageCache,
  dashboardSubmitOrderLog,
  dashboardManageConsumers,
];
